<template>
    <BaseChart :series="series" :extraOptions="options"></BaseChart>
</template>
<script>
import BaseChart from '@/views/Guide/charts/baseChart'

export default {
  name: 'InterestChart',
  props: ['series'],
  components: {
    BaseChart
  },
  data () {
    return {
    }
  },
  computed: {
    options () {
      return {
        data: {
          csv: '"null";"HPC含量";"Top3 含量";"HPC Rate";"Top5 Rate"\n"新聞時事";22.92;22.92;20.3;20.3\n"娛樂追星";8.16;" ";10.5;10.5\n"運動體育";4.87;" ";3.01;\n"旅遊美食";1.29;" ";2.33;\n"時尚美妝";2.58;" ";2.58;\n"財經投資";12.43;12.43;11.76;11.76\n"消費生活";10.65;10.65;7.65;7.65\n"健康保健";2.84;" ";1.02;\n"汽車";2.26;" ";3.11;\n"科技3C";7.91;" ";8.68;8.68\n"房屋地產";1.18;" ";2.39;\n"寵物動物";1.01;" ";1.66;\n"婦女家庭";3.32;" ";2.11;\n"遊戲";0.78;" ";0.12;\n"社群分享";8.85;" ";7.43;\n"夜貓族";8.94;" ";5.44;',
          googleSpreadsheetKey: false,
          googleSpreadsheetWorksheet: false
        }
      }
    }
  }
}
</script>
<style lang='scss' scoped>
</style>
